import React from 'react'
import { Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    englishTag: {
        backgroundColor: '#ebf7fe',
        color: '#066298',
    },
}));

export const EnglisTag = ({ content, size = 'small' }) => {
    const classes = useStyles();
    return (
        <Chip
            label={`英語力：${content}`}
            className={classes.englishTag}
            size={size}
        />
    )
}
